import { inject, Injectable } from '@angular/core';
import {AccountStoreService} from "../services/account-store.service";
import {Account} from "../../domain/model/account.model";

@Injectable({ providedIn: 'root' })
export class LinkBookingUseCase {
  private readonly accountStore = inject(AccountStoreService);

  execute(account: Account, bookingId: string): void {
    if (!account || !bookingId) {
      return;
    }

    account.updateBookingId(bookingId);
    this.accountStore.saveSelectedAccount(account);
  }
}
